import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Shield } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { authDisabled, cognitoConfigured } from "@/lib/authConfig";
import { useAuth } from "@/lib/AuthProvider";

/** Accesso volontario (menu o URL diretto). Dopo logout si usa /auth/exit → Cognito. */
export function Login() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!auth.ready || !auth.authenticated) return;
    navigate("/", { replace: true });
  }, [auth.ready, auth.authenticated, navigate]);

  if (!auth.ready) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Caricamento…
      </div>
    );
  }

  if (auth.authenticated) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Reindirizzamento…
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-lg bg-primary font-bold text-primary-foreground">
            R
          </div>
          <CardTitle>RENTRI Suite</CardTitle>
          <p className="text-sm text-muted-foreground">
            Accedi con il tuo account per usare l&apos;applicazione.
          </p>
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          {authDisabled ? (
            <Button
              className="w-full"
              onClick={() => {
                void auth.login();
              }}
            >
              Continua (modalità sviluppo)
            </Button>
          ) : cognitoConfigured() ? (
            <Button
              className="w-full"
              onClick={() => {
                void auth.login();
              }}
            >
              <Shield className="mr-2 h-4 w-4" />
              Accedi con Cognito
            </Button>
          ) : (
            <p className="text-center text-sm text-destructive">
              Cognito non configurato (variabili VITE_COGNITO_* mancanti).
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
